var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ffffff",
    height: 54,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "5.0 6.8 54.0 54.0",
    width: 54,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 9",
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 35.357H47V60.857H41z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 30.857H35V60.857H29z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 39.357H23V60.857H17z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 29.357H11V60.857H5z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 20.625H59V60.857H53z",
    fill: "inherit"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.224 28.369L7.523 17.906 8.477 16.748 20.276 26.471 31.877 17.965 44.244 22.349 55.412 8.223 56.588 9.152 44.756 24.122 32.123 19.645 20.224 28.369z",
    fill: "inherit"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "change2_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.054,
    cy: 17.35,
    fill: "#ffffff",
    rx: 1.165,
    ry: 1.187,
    transform: "rotate(-9.796 8.053 17.347)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "change1_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.062,19.137H8.056a1.8,1.8,0,0,1-1.247-3.059,1.918,1.918,0,0,1,1.243-.514A1.8,1.8,0,0,1,9.3,18.624,1.739,1.739,0,0,1,8.062,19.137Zm-.016-2.373a.544.544,0,0,0-.388.162.6.6,0,0,0,.4,1.012h0a.543.543,0,0,0,.387-.163.594.594,0,0,0-.4-1.011Z",
    fill: "inherit"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "change2_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.304,
    cy: 27.368,
    fill: "#ffffff",
    rx: 1.165,
    ry: 1.187,
    transform: "rotate(-9.796 20.3 27.366)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "change1_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.312,29.154h-.006A1.795,1.795,0,0,1,19.059,26.1a1.577,1.577,0,0,1,1.243-.514,1.8,1.8,0,0,1,1.246,3.06A1.738,1.738,0,0,1,20.312,29.154ZM20.3,26.781a.548.548,0,0,0-.388.162.6.6,0,0,0,.4,1.012h0a.546.546,0,0,0,.387-.162.6.6,0,0,0-.4-1.012Z",
    fill: "inherit"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "change2_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.025,
    cy: 18.761,
    fill: "#ffffff",
    rx: 1.165,
    ry: 1.187,
    transform: "rotate(-9.796 32.023 18.76)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "change1_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.032,20.547h-.006a1.8,1.8,0,0,1-1.245-3.06,1.738,1.738,0,0,1,1.237-.512h.005a1.795,1.795,0,0,1,1.246,3.059A1.739,1.739,0,0,1,32.032,20.547Zm0-1.2h0a.548.548,0,0,0,.388-.162.6.6,0,0,0-.4-1.012h0a.542.542,0,0,0-.388.162.6.6,0,0,0,.4,1.012Z",
    fill: "inherit"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "change2_4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.446,
    cy: 23.132,
    fill: "#ffffff",
    rx: 1.165,
    ry: 1.187,
    transform: "rotate(-9.796 44.444 23.134)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "change1_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.454,24.918h-.006a1.8,1.8,0,0,1-1.246-3.06,1.738,1.738,0,0,1,1.236-.512h.006A1.795,1.795,0,0,1,45.691,24.4,1.736,1.736,0,0,1,44.454,24.918Zm-.016-2.373a.546.546,0,0,0-.387.162.6.6,0,0,0,.4,1.012h0a.548.548,0,0,0,.388-.162.6.6,0,0,0-.4-1.012Z",
    fill: "inherit"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "change2_5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.975,
    cy: 8.597,
    fill: "#ffffff",
    rx: 1.165,
    ry: 1.187,
    transform: "rotate(-9.796 55.975 8.6)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "change1_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.982,10.383h-.005a1.8,1.8,0,0,1-1.246-3.06,1.737,1.737,0,0,1,1.237-.512h.006A1.795,1.795,0,0,1,57.219,9.87,1.739,1.739,0,0,1,55.982,10.383ZM55.968,8.01a.544.544,0,0,0-.388.162.6.6,0,0,0,.4,1.012h0a.543.543,0,0,0,.388-.163.594.594,0,0,0-.4-1.011Z",
    fill: "inherit"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.30b032b9c0cbbf099fb629eaba12082e.svg";
export { ForwardRef as ReactComponent };